import * as types from '../constants/actionTypes'

const initialState = {
  isLoading: false,
  inProgressData: []
}

const Planning = (state = initialState, action) => {
  switch (action.type) {
    case types.LOADING_DATA:
      const result = { ...state, isLoading: action.isLoading }
      return result
    case types.GET_INPROGRESS_CEREMONY_DATA:
      return {...state, inProgressData: action.payload}
    default:
      return state
  }
}

export default Planning